import { render, staticRenderFns } from "./FixNegativeBalanceModal.vue?vue&type=template&id=13c0ea1c&scoped=true"
import script from "./FixNegativeBalanceModal.vue?vue&type=script&lang=js"
export * from "./FixNegativeBalanceModal.vue?vue&type=script&lang=js"
import style0 from "./FixNegativeBalanceModal.vue?vue&type=style&index=0&id=13c0ea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0ea1c",
  null
  
)

export default component.exports